import React from 'react';
import styles from './PageHeader.module.css';

export default function PageHeader({ eyebrow, title, description, actions, breadcrumbs }) {
  return (
    <header className={styles.header}>
      {breadcrumbs ? <nav className={styles.crumbs}>{breadcrumbs}</nav> : null}
      <div className={styles.row}>
        <div className={styles.text}>
          {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
          <h1 className={styles.title}>{title}</h1>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </header>
  );
}
